import { CampaignBody, CampaignType } from "@vviinn/user-managment-client-ts";
import {
  customNetSettingsByType,
  defaultGeneralSettings,
  defaultNotVPDSettings,
  defaultSettingsByType,
  textSearchNetsDefaults,
} from "./defaultValuesNewCampaign";
import { CampaignNetKey, RelevantNets } from "../../types";
import { TextSearchNumbericTitles } from "../../textSearch/types";

function reduceNetsToValid<T>(
  campaignNetDefaults: { net: T; value: number }[][],
  referenceNets: string[],
) {
  return campaignNetDefaults.filter((defaults) =>
    defaults.reduce(
      (acc, currentValue) =>
        acc && referenceNets.some((net) => net === currentValue.net),
      true,
    ),
  );
}

export const setPresetValues = (
  campaignType: CampaignType,
  { relevantSimilarities, relevantColors, relevantTextNets }: RelevantNets,
): CampaignBody => {
  if (campaignType === "VPD") {
    return {
      ...defaultGeneralSettings,
      ...defaultSettingsByType[campaignType],
    };
  }

  const initValues = {
    ...defaultGeneralSettings,
    ...defaultNotVPDSettings,
    ...defaultSettingsByType[campaignType],
  };

  if (campaignType !== "TEXT_SEARCH") {
    const campaignNetDefaults = customNetSettingsByType[campaignType];
    const allRelevantNets = [
      ...(relevantSimilarities ?? []),
      ...(relevantColors ?? []),
    ];
    const relevantDefaults = reduceNetsToValid<CampaignNetKey>(
      campaignNetDefaults,
      allRelevantNets,
    );
    if (relevantDefaults.length) {
      for (let defaultNetSetting of relevantDefaults[0])
        initValues[defaultNetSetting.net] = defaultNetSetting.value;
    }
  } else {
    const relevantDefaults = reduceNetsToValid<keyof TextSearchNumbericTitles>(
      textSearchNetsDefaults,
      relevantTextNets ?? [],
    );
    if (relevantDefaults.length) {
      for (let item of relevantDefaults[0]) {
        if (item.net.startsWith("darjeeling"))
          initValues.productWeights = { [item.net]: item.value };
        else initValues.imageWeights = { [item.net]: item.value };
      }
    }
  }
  return initValues;
};
